import React from 'react'
import ReactDOM from 'react-dom'
import { Router, Route, IndexRoute, browserHistory } from 'react-router'
// import registerServiceWorker from './registerServiceWorker';

// TRANSLATE
import { I18nextProvider } from 'react-i18next'
import i18n from './i18n'

// STYLES
import './index.css'

// COMPONENTS
import Header from './components/header/header.component'

// PAGES
import Home from './pages/home.page'

ReactDOM.render(
  <I18nextProvider i18n={i18n}>
    <Router history={browserHistory}>
      <Route path='/' component={Header}>
        <IndexRoute component={Home} i18n={i18n} />
      </Route>
    </Router>
  </I18nextProvider>
  , document.getElementById('root'))
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js